export default function reverseCards({ displayCards }: { displayCards: any[] }) {
  return [...displayCards].reverse();
}